import type { ReactNode } from 'react'
import Seo from './Seo'

export default function Prose({
  title,
  description,
  path,
  heading,
  children,
}: {
  title: string
  description: string
  path: string
  heading: string
  children: ReactNode
}) {
  return (
    <div className="mx-auto max-w-content px-4 py-8">
      <Seo title={title} description={description} path={path} />
      <h1 className="text-3xl">{heading}</h1>
      <div className="mt-4 space-y-3 text-text-body [&_h2]:mt-6 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-text [&_a]:text-brand-text [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mt-1">
        {children}
      </div>
    </div>
  )
}
